import { Toast, Alert } from "react-bootstrap";
import logo from "../assets/images/logo_black.png";
import { hideToast } from "../redux/slices/Toasts";
import { useAppDispatch } from "../redux/hooks";

export class SnackBarMessageProps {
    open: boolean = false;
    duration?: number = 6000;
    messages: string[] = [];

    severity?: "success" | "info" | "warning" | "error" = undefined;
    onClose?: () => void = () => {this.open = false}
}

export const SnackBarMessage = (props: SnackBarMessageProps) => {
    const dispatch = useAppDispatch();
    
    return (
        <div key="info">
            <div className="toast-container" style={{ position: "fixed", top: 20, right: 10 }}>
                <Toast onClose={() => dispatch(hideToast(1))} show={props.open} delay={props.duration || 6000} autohide>
                    <Toast.Header>
                        <strong className="me-auto">
                            <img src={logo} alt="brand-logo" height="10" className="me-1" />
                        </strong>
                    </Toast.Header>
                    <Toast.Body>
                    {props.messages.map((item, index) => <div key={index}>
                        {item} 
                        {index === props.messages.length - 1 ? (<></>) : (<br/>)}
                    </div>)}
                    </Toast.Body>
                </Toast>
            </div>
        </div>
    );
};